import TranslationProvider, { Translation } from '../i18n/TranslationProvider';
import DocumentTitle from './DocumentTitle';
import Header from './Layout/Header';
import ContentWrapper from './Layout/ContentWrapper';
import Footer from './Layout/Footer';

const ErrorPage = ({ errorKey }) => (
    <TranslationProvider>
        <DocumentTitle titleKey={errorKey} />
        <Header />
        <ContentWrapper>
            <h1><Translation translationKey={errorKey} /></h1>
            <p><Translation translationKey={`${errorKey}Text`} /></p>
        </ContentWrapper>
        <Footer />
    </TranslationProvider>
);

export default ErrorPage;
